import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type ShareNavItem_AdHocAssetsShare_Fragment = { __typename?: 'AdHocAssetsShare', id: string, enabled: boolean, expiration?: string | null, expiresIn?: number | null, name: string, url?: string | null, useOriginHeader: boolean, creator: { __typename?: 'AuthenticatedUser', id: string }, thumbnailAssets?: Array<{ __typename?: 'InboxItemAsset', id?: string | null, assetType?: Types.AssetTypeEnum | null, filetype?: string | null, hasAlpha?: boolean | null, thumbnailImageUrl?: { __typename?: 'ImageTranscodeUrl', url: string } | null } | null> | null };

export type ShareNavItem_CollectionShare_Fragment = { __typename?: 'CollectionShare', id: string, enabled: boolean, expiration?: string | null, expiresIn?: number | null, name: string, url?: string | null, useOriginHeader: boolean, creator: { __typename?: 'AuthenticatedUser', id: string }, thumbnailAssets?: Array<{ __typename?: 'InboxItemAsset', id?: string | null, assetType?: Types.AssetTypeEnum | null, filetype?: string | null, hasAlpha?: boolean | null, thumbnailImageUrl?: { __typename?: 'ImageTranscodeUrl', url: string } | null } | null> | null };

export type ShareNavItemFragment = ShareNavItem_AdHocAssetsShare_Fragment | ShareNavItem_CollectionShare_Fragment;

export type ShareNavThumbnailFragment = { __typename?: 'InboxItemAsset', id?: string | null, assetType?: Types.AssetTypeEnum | null, filetype?: string | null, hasAlpha?: boolean | null, thumbnailImageUrl?: { __typename?: 'ImageTranscodeUrl', url: string } | null };

export const ShareNavThumbnail = /*#__PURE__*/ gql`
    fragment ShareNavThumbnail on InboxItemAsset {
  id
  assetType
  filetype
  hasAlpha
  thumbnailImageUrl {
    url
  }
}
    ` as unknown as DocumentNode<ShareNavThumbnailFragment, unknown>;
export const ShareNavItem = /*#__PURE__*/ gql`
    fragment ShareNavItem on Share {
  id
  creator {
    id
  }
  enabled
  expiration
  expiresIn
  name
  thumbnailAssets {
    ...ShareNavThumbnail
  }
  url
  useOriginHeader
}
    ${ShareNavThumbnail}` as unknown as DocumentNode<ShareNavItemFragment, unknown>;

        

        
export const useShareNavItemFragment = (
  input: string | Omit<UseFragmentOptions<ShareNavItemFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Share' } };
    return input;
  })();

  return useFragment<ShareNavItemFragment>({
    fragment: ShareNavItem,
    fragmentName: 'ShareNavItem',
    ...options,
  });
};
  
        
        

        
export const useShareNavThumbnailFragment = (
  input: string | Omit<UseFragmentOptions<ShareNavThumbnailFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'InboxItemAsset' } };
    return input;
  })();

  return useFragment<ShareNavThumbnailFragment>({
    fragment: ShareNavThumbnail,
    fragmentName: 'ShareNavThumbnail',
    ...options,
  });
};
  
        